import { Component } from '@angular/core';
import { IonicPage, NavParams, NavController,LoadingController } from 'ionic-angular';

import { WorkflowApproval, GlobalVarApproval } from '@providers/index';

// @IonicPage()
@Component({
  selector: 'page-list-task',
  templateUrl: 'list-task.html'
})
export class ListTaskPageApproval {
  listMyTask = [];
  wfSelected : any;
  is_mytask=1;

  constructor(public navCtrl: NavController,
    public workflow: WorkflowApproval,
    public globalvar:GlobalVarApproval,
    public loadingCtrl: LoadingController,
    navParams: NavParams
  ) {
    this.wfSelected = navParams.get('workflow');
    this.is_mytask = navParams.get('is_mytask');
  }

  doRefresh(refresher) {
    refresher.complete();
    this.get_data();
  }

  get_data(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      User_ID : this.globalvar.app_user.user_attribute.id,
      Workflow_ID : this.wfSelected.Workflow_ID
    };

    if(this.is_mytask){
      this.workflow.get_task(params).subscribe((resp:any) => {
        this.listMyTask = resp.data;
        loading.dismiss();
      }, (err) => {
        loading.dismiss();     
      });
    }else{
      this.workflow.get_task_monitoring(params).subscribe((resp:any) => {
        this.listMyTask = resp.data;
        loading.dismiss();
      }, (err) => {
        loading.dismiss();     
      });
    }

  }



  /**
   * The view loaded, let's query our items for the list
   */
  ionViewDidEnter() {
    if(this.wfSelected){
      this.get_data();
    }
  }
 
  /**
   * Navigate to the detail page for this item.
   */
  list_task(item) {
    this.navCtrl.push('ItemDetailPage', {
      task: item,
      is_mytask:this.is_mytask
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/aproval_erp/list-task/list-task.ts